module.exports = __webpack_public_path__ + "static/media/display.8a358a8c.svg";